import BarChartRounded from "@mui/icons-material/BarChartRounded";
import ShoppingCartRounded from "@mui/icons-material/ShoppingCartRounded";
import StorefrontRounded from "@mui/icons-material/StorefrontRounded";
import AttachMoneyRounded from "@mui/icons-material/AttachMoneyRounded";
import LocalShippingRounded from "@mui/icons-material/LocalShippingRounded";
import PeopleAltRounded from "@mui/icons-material/PeopleAltRounded";
import InsightsRounded from "@mui/icons-material/InsightsRounded";
import { SvgIconComponent } from "@mui/icons-material";

export const ICON_MAP: Record<string, SvgIconComponent> = {
  BarChartRounded,
  ShoppingCartRounded,
  StorefrontRounded,
  AttachMoneyRounded,
  LocalShippingRounded,
  PeopleAltRounded,
};

export function iconFor(name?: string): SvgIconComponent {
  if (name && ICON_MAP[name]) return ICON_MAP[name];
  return InsightsRounded;
}
